module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aboutus"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-9"
  }, [_c('div', {
    staticClass: "text-main-container",
    attrs: {
      "data-aos": "fade-down"
    }
  }, [_c('div', {
    staticClass: "small-title"
  }, [_c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.historyHome.title)
    }
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "text-container"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.state.historyHome.subTitle)
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "max-width": "500px"
    }
  }, [_vm._v(_vm._s(_vm.state.historyHomepTextTop))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "max-width": "500px"
    }
  }, [_vm._v(" " + _vm._s(_vm.state.historyHome.pTextBottom) + " ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "transform": "skew(10deg)"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/nosotros",
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.state.historyHome.btnText))])], 1)])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "truck-img-contqainer",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": require("../../assets/imgs/home_foto3_roja.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 display-none-minres",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/home_foto2.png"),
      "width": "100%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cc0bff6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HistoryPage.vue
// module id = 153
// module chunks = 0